module.exports = __webpack_public_path__ + "static/media/about-us.99342884.png";